

















import { defineComponent } from '@vue/composition-api';
import { SdsIcon } from '@superbet-group/web.lib.ui-components';

export default defineComponent({
    props: {
        label: {
            type: String,
            required: true,
        },
        icon: {
            type: String,
            required: false,
            default: undefined,
        },
        itemClasses: {
            type: String,
            required: false,
            default: undefined,
        },
        destination: {
            type: Object,
            required: true,
        },
    },
    components: {
        SdsIcon,
    },
});
